export let MenuItemActionType;
(function (MenuItemActionType) {
  MenuItemActionType["ADD_MENU_ITEM"] = "ADD_MENU_ITEM";
  MenuItemActionType["HIDE_MENU_ITEM"] = "HIDE_MENU_ITEM";
  MenuItemActionType["FOCUS_FIRST_MENU_ITEM"] = "FOCUS_FIRST_MENU_ITEM";
  MenuItemActionType["FOCUS_LAST_MENU_ITEM"] = "FOCUS_LAST_MENU_ITEM";
  MenuItemActionType["FOCUS_NEXT_MENU_ITEM"] = "FOCUS_NEXT_MENU_ITEM";
  MenuItemActionType["FOCUS_PREVIOUS_MENU_ITEM"] = "FOCUS_PREVIOUS_MENU_ITEM";
  MenuItemActionType["FOCUS_RESET"] = "FOCUS_RESET";
})(MenuItemActionType || (MenuItemActionType = {}));